import i18n from "i18next";
import account from "locales/en/account.json";
import address from "locales/en/address.json";
import admin from "locales/en/admin.json";
import ai from "locales/en/ai.json";
import allocation from "locales/en/allocation.json";
import auditing from "locales/en/auditing.json";
import auth from "locales/en/auth.json";
import calculation from "locales/en/calculation.json";
import capitalActivity from "locales/en/capital-activity.json";
import capitalCall from "locales/en/capital-call.json";
import closing from "locales/en/closing.json";
import commitment from "locales/en/commitment.json";
import commitmentClass from "locales/en/commitment-classes.json";
import common from "locales/en/common.json";
import creditFacility from "locales/en/credit-facility.json";
import dashboard from "locales/en/dashboard.json";
import distribution from "locales/en/distribution.json";
import entity from "locales/en/entity.json";
import enums from "locales/en/enums.json";
import equalization from "locales/en/equalization.json";
import errors from "locales/en/errors.json";
import events from "locales/en/events.json";
import fees from "locales/en/fees.json";
import financialReporting from "locales/en/financial-reporting.json";
import fundFamily from "locales/en/fund-family.json";
import generalLedger from "locales/en/general-ledger.json";
import internal from "locales/en/internal.json";
import investment from "locales/en/investment.json";
import investor from "locales/en/investor.json";
import investorEntity from "locales/en/investor-entity.json";
import investorTransfer from "locales/en/investor-transfer.json";
import notices from "locales/en/notices.json";
import reports from "locales/en/reports.json";
import settings from "locales/en/settings.json";
import views from "locales/en/views.json";
import waterfall from "locales/en/waterfall.json";
import { initReactI18next } from "react-i18next";

/*eslint sort-keys: "error"*/

export const defaultNS = "common";

export const resources = {
  en: {
    account,
    address,
    admin,
    ai,
    allocation,
    auditing,
    auth,
    calculation,
    capitalActivity,
    capitalCall,
    closing,
    commitment,
    commitmentClass,
    common,
    creditFacility,
    dashboard,
    distribution,
    entity,
    enums,
    equalization,
    errors,
    events,
    fees,
    financialReporting,
    fundFamily,
    generalLedger,
    internal,
    investment,
    investor,
    investorEntity,
    investorTransfer,
    notices,
    reports,
    settings,
    views,
    waterfall,
  },
} as const;

void i18n.use(initReactI18next).init({
  defaultNS,
  interpolation: {
    escapeValue: false,
  },
  lng: "en",
  ns: [
    "account",
    "address",
    "admin",
    "ai",
    "allocation",
    "auditing",
    "auth",
    "capitalActivity",
    "capitalCall",
    "closing",
    "commitment",
    "commitmentClass",
    "common",
    "creditFacility",
    "dashboard",
    "distribution",
    "entity",
    "enums",
    "equalization",
    "errors",
    "events",
    "fees",
    "financialReporting",
    "fundFamily",
    "generalLedger",
    "internal",
    "investment",
    "investor",
    "investorEntity",
    "investorTransfer",
    "notices",
    "reports",
    "settings",
    "setup",
    "waterfall",
  ],
  resources,
});

export default i18n;
